export const DEFAULT_COPYRIGHT_NID = 1077;
